// Server-driven catalog availability. The rich presentation catalog (labels, samples,
// output fields, icons) stays in nodeCatalog.js, but WHICH triggers/systems are actually
// available is decided by the server's GET /admin/automation-flows/bricks — so Arbox and
// Fireberry appear automatically once their trigger bricks are registered server-side,
// and nothing shows in the picker that the server can't run.
//
// Usage: call loadCatalog() once when the builder / v2 page mounts. Until it resolves,
// availableTriggerKinds() returns null → nodeCatalog falls back to showing everything
// (so a slow/failed fetch degrades to the static catalog rather than an empty picker).

import {getBrickCatalog} from "../../../services/AutomationFlowService";

let state = {
    loaded: false,
    triggerKinds: null,   // Set<string> of TriggerKind names the server registered, or null (unknown)
    systems: null,        // Set<string> of TriggerSystem names available, or null
    actionKinds: null,    // Set<string> of ACTION brick kinds the server can run, or null
    dataKinds: null,      // Set<string> of DATA brick kinds, or null
    bricks: null,         // raw /bricks response
};

export async function loadCatalog() {
    try {
        const res = await getBrickCatalog();
        const bricks = res?.data || [];
        const byCat = (c) => new Set(bricks.filter(b => b.category === c).map(b => b.kind));
        const triggers = bricks.filter(b => b.category === "TRIGGER");
        state = {
            loaded: true,
            triggerKinds: new Set(triggers.map(t => t.kind)),
            systems: new Set(triggers.map(t => t.system).filter(Boolean)),
            actionKinds: byCat("ACTION"),
            dataKinds: byCat("DATA"),
            bricks,
        };
    } catch (e) {
        // Leave availability unknown → the palette/picker shows the full static catalog.
        state = {...state, loaded: true};
    }
    return state;
}

// null → "unknown, show everything"; a Set → "only these are available".
export const availableTriggerKinds = () => state.triggerKinds;
export const availableSystems = () => state.systems;
export const availableActionKinds = () => state.actionKinds;
export const availableDataKinds = () => state.dataKinds;
export const catalogBricks = () => state.bricks;
export const isCatalogLoaded = () => state.loaded;
